import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthUser } from '../models/auth-user.model';
import { AuthenticationService } from '../services/authentication.service';
import { UserService } from '../services/user.service';
import { PermissionHelper } from './permission.helper';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate, CanActivateChild {

    private isAuthenticated: boolean;
    private currentUser: AuthUser;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private userService: UserService
    ) {
        this.authenticationService.auth.subscribe(res => {
            this.isAuthenticated = !!res;
        });
        this.userService.currentUser.subscribe(user => {
            this.currentUser = user;
        });
    }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<boolean> | Promise<boolean> | boolean {

        if (!this.isAuthenticated) {
            this.router.navigate(['login']);
            return false;
        }

        let hasPermission = true;
        if (route.data && !!route.data.requiredPermissions) {
          hasPermission = PermissionHelper.evaluatePermission(route.data.requiredPermissions, this.currentUser)
        }
        return hasPermission;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
        Observable<boolean> | Promise<boolean> | boolean {
        return this.canActivate(route, state);
    }
}
